import React from "react";
import Product from "../product/Product";
import "./productList.css";
import { projects, personalProjects } from "../../data";

const ProductList = () => {
  return (
    <div className="projects-section">
      <div className="projects-container">
        
        {/* Enterprise Flagship Projects */}
        <div className="projects-header">
          <h2 className="section-title">Enterprise Case Studies</h2>
          <p className="section-desc">
            Production-grade web systems built for prominent clients during my tenure at NTT DATA. 
            Focused on performance, complex state, and custom analytics dashboards.
          </p>
        </div>
        
        <div className="projects-grid enterprise">
          {projects.map((project) => (
            <Product key={project.id} project={project} isEnterprise={true} />
          ))}
        </div>

        {/* Personal & Open Source Projects */}
        <div className="projects-header personal-header">
          <h2 className="section-title secondary-title">Personal Explorations</h2>
          <p className="section-desc">
            Independent projects exploring user experiences, database integrations, and experimental technologies.
          </p>
        </div>

        <div className="projects-grid personal">
          {personalProjects.map((project) => (
            <Product key={project.id} project={project} isEnterprise={false} />
          ))}
        </div>

      </div>
    </div>
  );
};

export default ProductList;
